/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createCustomRole } from '../fn/administration-role/create-custom-role';
import { CreateCustomRole$Params } from '../fn/administration-role/create-custom-role';
import { deleteCustomRole } from '../fn/administration-role/delete-custom-role';
import { DeleteCustomRole$Params } from '../fn/administration-role/delete-custom-role';
import { getCustomRole } from '../fn/administration-role/get-custom-role';
import { GetCustomRole$Params } from '../fn/administration-role/get-custom-role';
import { Role } from '../models/role';
import { RolePagedList } from '../models/role-paged-list';
import { searchCustomRoleList$Any } from '../fn/administration-role/search-custom-role-list-any';
import { SearchCustomRoleList$Any$Params } from '../fn/administration-role/search-custom-role-list-any';
import { searchCustomRoleList$Json } from '../fn/administration-role/search-custom-role-list-json';
import { SearchCustomRoleList$Json$Params } from '../fn/administration-role/search-custom-role-list-json';
import { updateCustomRole } from '../fn/administration-role/update-custom-role';
import { UpdateCustomRole$Params } from '../fn/administration-role/update-custom-role';


/**
 * All about the administration roles features
 */
@Injectable({ providedIn: 'root' })
export class AdministrationRoleService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchCustomRoleList()` */
  static readonly SearchCustomRoleListPath = '/custom/administration/roles/search';

  /**
   * Retrieve a role list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchCustomRoleList$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchCustomRoleList$Json$Response(params?: SearchCustomRoleList$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RolePagedList>> {
    return searchCustomRoleList$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a role list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchCustomRoleList$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchCustomRoleList$Json(params?: SearchCustomRoleList$Json$Params, context?: HttpContext): Observable<RolePagedList> {
    return this.searchCustomRoleList$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RolePagedList>): RolePagedList => r.body)
    );
  }

  /**
   * Retrieve a role list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchCustomRoleList$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchCustomRoleList$Any$Response(params?: SearchCustomRoleList$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<RolePagedList>> {
    return searchCustomRoleList$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a role list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchCustomRoleList$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchCustomRoleList$Any(params?: SearchCustomRoleList$Any$Params, context?: HttpContext): Observable<RolePagedList> {
    return this.searchCustomRoleList$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<RolePagedList>): RolePagedList => r.body)
    );
  }

  /** Path part for operation `createCustomRole()` */
  static readonly CreateCustomRolePath = '/custom/administration/roles';

  /**
   * Create a role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCustomRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCustomRole$Response(params: CreateCustomRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createCustomRole(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCustomRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCustomRole(params: CreateCustomRole$Params, context?: HttpContext): Observable<void> {
    return this.createCustomRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getCustomRole()` */
  static readonly GetCustomRolePath = '/custom/administration/roles/{uid}';

  /**
   * Retrieve a specific role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomRole$Response(params: GetCustomRole$Params, context?: HttpContext): Observable<StrictHttpResponse<Role>> {
    return getCustomRole(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a specific role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomRole(params: GetCustomRole$Params, context?: HttpContext): Observable<Role> {
    return this.getCustomRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<Role>): Role => r.body)
    );
  }

  /** Path part for operation `updateCustomRole()` */
  static readonly UpdateCustomRolePath = '/custom/administration/roles/{uid}';

  /**
   * Update a role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCustomRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCustomRole$Response(params: UpdateCustomRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateCustomRole(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCustomRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCustomRole(params: UpdateCustomRole$Params, context?: HttpContext): Observable<void> {
    return this.updateCustomRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteCustomRole()` */
  static readonly DeleteCustomRolePath = '/custom/administration/roles/{uid}';

  /**
   * Delete a role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCustomRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCustomRole$Response(params: DeleteCustomRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteCustomRole(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCustomRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCustomRole(params: DeleteCustomRole$Params, context?: HttpContext): Observable<void> {
    return this.deleteCustomRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
